

function Card({children, version}) {
    return (
      <div className={`card card-${version}`}>
          {children}
      </div>
    )
  }
  
  Card.defaultProps = {
      version : 'primary'
  }
  

export default Card